import { useAtom } from "jotai";
import { useEffect } from "react";
import { match, P } from "ts-pattern";

import { showLoadingSpinnerAtom } from "../lander-quiz/lander-quiz.state";
import { LoadingSpinner } from "../shared/components/loading-spinner/loading-spinner.component";

import { Layout } from "./components/layout/layout.component";
import { OptInPage } from "./components/opt-in-page/opt-in-page.component";
import { PlaidPage } from "./components/plaid/plaid.component";
import { PlaidRetryPage } from "./components/plaid-retry/plaid-retry.component";
import { RegistrationPage } from "./components/registration/registration.component";
import { RegistrationRetryPage } from "./components/registration-retry/registration-retry.component";
import { VerificationPage } from "./components/verification/verification.component";
import { VerificationRetryPage } from "./components/verification-retry/verification-retry.component";
import { FKC_MAX_CARD_COUNT } from "./fkc.constants";
import { pagesAtom, userDataAtom, progressAtom } from "./fkc.state";
import { FallbackPages, Pages } from "./fkc.types";

export function Widget() {
  const [page, setPage] = useAtom(pagesAtom);
  const [isLoading] = useAtom(showLoadingSpinnerAtom);
  const [userData] = useAtom(userDataAtom);
  const [progress] = useAtom(progressAtom);

  useEffect(() => {
    if (!userData) {
      return;
    }

    match(userData)
      .with({ cards_count: P.when((cards) => cards >= FKC_MAX_CARD_COUNT) }, () => window.theme.FkcUtils.skip())
      .with({ is_verified: false }, () => setPage(Pages.VERIFICATION))
      .with({ is_verified: true }, () => setPage(Pages.PLAID))
      .exhaustive();
  }, [userData, setPage]);

  if (isLoading) {
    return LoadingSpinner;
  }

  return (
    <Layout progress={progress}>
      {match(page)
        .with(Pages.OPTIN, () => <OptInPage />)
        .with(Pages.REGISTRATION, () => <RegistrationPage />)
        .with(FallbackPages.REGISTRATION_RETRY, () => <RegistrationRetryPage />)
        .with(Pages.VERIFICATION, () => <VerificationPage />)
        .with(FallbackPages.VERIFICATION_RETRY, () => <VerificationRetryPage />)
        .with(Pages.PLAID, () => <PlaidPage />)
        .with(FallbackPages.PLAID_RETRY, () => <PlaidRetryPage />)
        .exhaustive()
      }
    </Layout>
  );
}
